/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectWalletsData } from '../modules/wallets/selectors';
import { IWallet } from '../services/client/types';
import { walletsResponse } from '../pages/dashboard/mocks';

const WALLETS_ORDER = ['USD', 'MXN', 'COP', 'EUR', 'GBP', 'CAD', 'HKD'];

const useWalletsMixed = () => {
  const wallets = useSelector(selectWalletsData);

  const walletsDataMixed = useMemo<IWallet[] | undefined>(() => {
    let newArray = wallets || [];
    if (!newArray.length) return undefined;
    walletsResponse.forEach((item) => {
      const itemExists = newArray.find(
        (element: IWallet) => element.currency.name === item.currency.name
      );
      if (!itemExists) newArray = [...newArray, item];
    });
    const sortedArray = newArray
      .slice()
      .sort(
        (it1, it2) =>
          WALLETS_ORDER.indexOf(it1.currency.name) -
          WALLETS_ORDER.indexOf(it2.currency.name)
      );

    return sortedArray;
  }, [wallets]);

  return { walletsDataMixed };
};

export default useWalletsMixed;
